import { Extracts } from '../components/fulfilment/index';
import { FSRThresholds } from '../components/futureSecurity';
import NavigationBar from '../components/navigation/navigationBar';

const DynamicThresholds: React.FC = () => {
  return (
    <div className="wrapper">
      <NavigationBar />
      <section className="container">
        <FSRThresholds />
      </section>
    </div>
  );
}

export default DynamicThresholds